export const ROUTE_PATH = '/users/:userId';
